import Navina1 from '../Navara/Navina (1).webp'
import Navina2 from '../Navara/Navina (3).webp'




const Navinaimages =[
Navina1,Navina2
]

export default Navinaimages;